import { scholarshipTypeActionTypes } from 'src/store/actions/scholarshipType.actions';
import { ScholarshipTypeState } from 'src/store/initial.state';

const ScholarshipTypeReducer = (state = new ScholarshipTypeState(), { type, payload } = {}) => {
  switch (type) {
    case scholarshipTypeActionTypes.GET_SCHOLARSHIP_TYPES_SUCCESS:
      return { ...state, types: payload };

    case scholarshipTypeActionTypes.GET_SCHOLARSHIP_DOCUMENTS_SUCCESS:
      return { ...state, documents: payload };

    default:
      return state;
  }
};

export { ScholarshipTypeReducer };
